<template>
  <FormKit
      type="file"
      :name="name"
      :label="label"
      :help="help || (multiple && '파일은 최대 10개까지 업로드할 수 있습니다.')"
      :accept="accept"
      :multiple="multiple"
      :validation="validation"
      @input="handleFileInput"
      :validation-messages="{required: `[${label}] 등록 필수`}"
  />
</template>

<script setup>
import {computed} from "vue";

const props = defineProps({
  name: String,
  label: String,
  help: String,
  validation: String,
  accept: String,
  multiple: Boolean,
  maxFileSize: String // MB 단위
})

const handleFileInput = (value, node) => {

  const maxSizeMB = parseFloat(props.maxFileSize || '1')
  const maxSizeBytes = maxSizeMB * 1024 * 1024
  const files = Array.isArray(value) ? value : [value]

  // ✅ 파일 개수 초과 검사
  if (props.multiple && files.length > 10) {
    node?.input(null) // 파일 제거
    alert(`파일은 최대 10개까지 업로드할 수 있습니다.`)
    return
  }

  // ✅ 개별 파일 크기 검사
  for (const item of files) {
    const file = item?.file || item
    if (file && file.size > maxSizeBytes) {
      node?.input(null) // 파일 제거
      alert(`"${file.name}" 파일은 ${maxSizeMB}MB를 초과하여 업로드할 수 없습니다.`)
      return
    }
  }
}

</script>
